import { useNotifications } from '../contexts/NotificationContext';

/**
 * Simple toast hook that wraps the notification system.
 * Use instead of window.alert(), window.confirm(), etc.
 * 
 * Usage:
 *   const toast = useToast();
 *   toast.success('Item saved!');
 *   toast.error('Something went wrong');
 *   toast.info('Processing...');
 *   toast.warning('Are you sure?');
 *   const confirmed = await toast.confirm('Delete this item?');
 */
export const useToast = () => {
  const { addNotification } = useNotifications();

  const success = (message, title = 'Success') => {
    addNotification({ type: 'success', title, message });
  };

  const error = (message, title = 'Error') => {
    addNotification({ type: 'error', title, message });
  };

  const info = (message, title = 'Info') => {
    addNotification({ type: 'info', title, message });
  };

  const warning = (message, title = 'Warning') => {
    addNotification({ type: 'warning', title, message });
  };

  return { success, error, info, warning };
};

export default useToast;
